import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { FaMapMarkerAlt, FaCalendarAlt, FaClock, FaDailymotion, FaArrowDown, FaHotTub } from "react-icons/fa";

const API_URL = process.env.REACT_APP_IS_PROD == "true" ? process.env.REACT_APP_API_URL_PROD : process.env.REACT_APP_API_URL_DEV


export default ({ tourId }) => {

    const [itinerary, setItinerary] = useState(null);

    useEffect(() => {

        const fetchItinerary = async () => {
            try {
                const response = await fetch(`${API_URL}/web/tours/itinerary/?tourid=${tourId}`, {
                    headers: {
                        'X-API-Key': process.env.REACT_APP_ACCESS_API_KEY // Add API key to headers
                    }
                });
                const result = await response.json();

                if (result.header.resCode === 200 && result.data.length > 0) {
                    setItinerary(result.data)
                }
            } catch (error) {
                console.error('Error fetching itinerary data:', error);
            }
        };

        fetchItinerary();

    }, [tourId]);

    return (
        <> {itinerary &&
            <Container>
                <Timeline>
                    {itinerary.map((item, index) => (
                        <TimelineItem key={index} isRight={index % 2 !== 0}>
                            <Dot />
                            <Content
                                as={motion.div}
                                initial={{ opacity: 0, x: index % 2 === 0 ? -100 : 100 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.5, delay: index * 0.1 }}
                            >
                                {/* <h3>Day {item.day}</h3> */}
                                <p><FaCalendarAlt /> {item.day} </p>
                                {/* <p><FaCalendarAlt /> {new Date(item.date).toLocaleString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" }).replace(',', '')}</p> */}
                                {/* <p><FaClock /> {item.time}</p> */}
                                <p><FaMapMarkerAlt /> {item.location}</p>
                                <p><FaHotTub /> Activity List</p>
                                <br />
                                {item.activity.map((activityItem, index) => (
                                    <ul><Activity>• {activityItem}</Activity></ul>
                                )
                                )}
                            </Content>
                        </TimelineItem>
                    ))}
                </Timeline>
            </Container>}
        </>
    );
};


// Styled Components
const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    background:rgb(255, 255, 255);
`;

const Title = styled.h2`
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 30px;

    @media (max-width: 768px) {
       font-size: 18px;
       font-weight: bold;
    }
`;

const Timeline = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    max-width: 800px;

    &:before {
        content: "";
        position: absolute;
        top: 0;
        left: 50%;
        width: 4px;
        height: 100%;
        background: #007bff;
        transform: translateX(-50%);
    }

    @media (max-width: 768px) {
        &:before {
            left: 2px;
        }
    }
`;

const TimelineItem = styled.div`
    display: flex;
    justify-content: ${(isRight) => (isRight ? "flex-start" : "flex-end")};
    align-items: center;
    width: 100%;
    position: relative;
    margin: 10px 0;

    &:nth-child(even) {
        flex-direction: row-reverse;
    }

    @media (max-width: 768px) {
        display:flex;
        flex-direction: column;
        align-items: center;
        justify-content:center;
    }
`;

const Content = styled(motion.div)`
    background: white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    max-width: 270px;
    min-width: 270px;
    text-align: left;
    transition: transform 0.3s ease-in-out;

    h3 {
        margin-bottom: 5px;
        color: #007bff;
    }

    p {
        margin: 2px 0;
        font-size: 14px;
        display: flex;
        align-items: center;
    }

    svg {
        margin-right: 5px;
        color: #007bff;
    }

    &:hover {
        transform: scale(1.05);
    }

    @media (max-width: 768px) {
        max-width: 70%;
    }
`;

const Activity = styled.p`
    font-weight: bold;
    color: #333;
`;

const Dot = styled.div`
    position: absolute;
    width: 15px;
    height: 15px;
    background: #007bff;
    border-radius: 50%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;

    @media (max-width: 768px) {
        left: 2px;
    }
`;
